// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._2hwx1i6y{margin-right:var(--ds-space-negative-025,-2px)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/InlineCard/ErroredView/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,8CAA8C","sourcesContent":["._2hwx1i6y{margin-right:var(--ds-space-negative-025,-2px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
